import React from "react";
import Hero from "Components/Hero";
import globalCss from "Global.module.css";
import heroImage from "Assets/Images/Heroes/about.jpg";
import css from "./FaqView.module.css";
import AboutHero from "Views/Common/AboutHero";
import { Footer } from "Partials";
import Accordion from "Components/UI/Accordion/Accordion";
import Icons from "Components/Icons";
import MobileHeader from "Views/AboutView/MobileHeader";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

export default function FaqView(): JSX.Element {
  const { t } = useTranslation();
  const heroHeight = 430;
  const isPhone = useMediaQuery({
    query: "(max-width: 900px)",
  });

  return (
    <>
      <Hero image={heroImage} height={heroHeight} />
      {isPhone ? (
        <MobileHeader title="FAQ" />
      ) : (
        <div className={globalCss.Content}>
          <section className={css.HeroTitle} style={{ height: heroHeight }}>
            <AboutHero className={css.AboutHero} />
          </section>
        </div>
      )}

      <article className={css.Content}>
        <section className={css.Header}>
          <h1>{t("faq-meaning") ?? "Hey"}</h1>
          <h4>{t("faq-short")}</h4>
        </section>

        <section className={css.Faqs}>
          <Accordion title={t("how-create-profile")}>
            <ol>
              <li>{t("how-profile-1")}</li>
              <li>{t("how-profile-2")}</li>
              <li>{t("how-profile-3")}</li>
              <li>{t("how-profile-4")}</li>
              <li>{t("how-profile-5")}</li>
            </ol>
          </Accordion>
          <Accordion title={t("how-create-list")}>
            <>
              <ol>
                <li>{t("how-list-1")}</li>
                <li>{t("how-list-2")}</li>
                <li>{t("how-list-3")}</li>
                <li>{t("how-list-4")}</li>
                <li>{t("how-list-5")}</li>
                <li>{t("how-list-6")}</li>
              </ol>
              <br />
              <p>{t("how-list-photo")}</p>
            </>
          </Accordion>
          <Accordion title={t("how-create-tip")}>
            <>
              <ol>
                <li>{t("how-tip-1")}</li>
                <li>{t("how-tip-2")}</li>
                <li>{t("how-tip-3")}</li>
                <li>{t("how-tip-4")}</li>
                <li>{t("how-tip-5")}</li>
                <li>{t("how-tip-6")}</li>
                <li>{t("how-tip-7")}</li>
                <li>{t("how-tip-8")}</li>
                <li>{t("how-tip-9")}</li>
              </ol>
              <br />
            </>
          </Accordion>
          <Accordion title={t("how-digest-tip")}>
            <>
              <p>{t("how-digest-1")}</p>
              <br />
              <div className={css.DigestTipItem}>
                <Icons.Map />
                <div>
                  <h5>{t("map")}</h5>
                  <p>{t("how-digest-2")}</p>
                </div>
              </div>
              <br />
              <div className={css.DigestTipItem}>
                <Icons.Details className={css.DetailsIcon} />
                <div>
                  <h5>{t("details")}</h5>
                  <p>{t("how-digest-3")}</p>
                </div>
              </div>
              <br />
              <div className={css.DigestTipItem}>
                <Icons.Star />
                <div>
                  <h5>{t("borrow")}</h5>
                  <p>{t("how-digest-4")}</p>
                </div>
              </div>
              <br />
              <div className={css.DigestTipItem}>
                <Icons.Menu className={css.MenuIcon} />
                <div>
                  <h5>{t("edit-etc")}</h5>
                  <p>{t("how-digest-5")}</p>
                </div>
              </div>
              <br />
              <div className={css.DigestTipItem}>
                <Icons.Report />
                <div>
                  <h5>{t("report")}</h5>
                  <p>{t("how-digest-6")}</p>
                </div>
              </div>
              <br />
              <div className={css.DigestTipItem}>
                <Icons.Copy />
                <div>
                  <h5>{t("export")}</h5>

                  <p>{t("how-digest-7")}</p>
                </div>
              </div>
            </>
          </Accordion>
          <Accordion title={t("how-use-explorer")}>
            <>
              <p>{t("how-explorer-desc")}</p>
              <br />
              <ul>
                <li>{t("how-explorer-1")}</li>
                <li>{t("how-explorer-2")}</li>
                <li>{t("how-explorer-3")}</li>
                <li>{t("how-explorer-4")}</li>
              </ul>
            </>
          </Accordion>
          <Accordion title={t("how-save-draft")}>
            <>{t("how-save-draft-desc")}</>
          </Accordion>
          <Accordion title={t("how-search")}>
            <>{t("how-search-desc")}</>
          </Accordion>
        </section>
      </article>
      <Footer />
    </>
  );
}
